import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { styled } from "@mui/material/styles";
import Slider from "react-slick"; // ✅ Import slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BlinkBlur } from "react-loading-indicators";

const ColorStepIconRoot = styled("div")(({ ownerState }) => ({
  backgroundColor: ownerState.hasImage ? "#4caf50" : "#f44336", // green or red
  zIndex: 1,
  color: "#fff",
  width: 32,
  height: 32,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  fontWeight: "bold",
}));

function ColorStepIcon(props) {
  const { icon, hasImage } = props;
  return (
    <ColorStepIconRoot ownerState={{ hasImage }}>
      {icon} {/* Step number */}
    </ColorStepIconRoot>
  );
}

const Steppers = ({
  summaryDetails,
  fleetDeliveryAgentList,
  handleImageOpen,
}) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [activeStep, setActiveStep] = useState(0);
  const [stepsforstartHubDel, setStepsforStartHubDel] = useState([]);
  const [getHubStart, setGetHubStart] = useState([]);
  const [loading,setLoading] = useState(true)
  

  useEffect(() => {
    if (
      fleetDeliveryAgentList[0]?.bookingDetails?.deliveryType ===
        "homeDelivery" ||
      fleetDeliveryAgentList[0]?.bookingDetails?.deliveryTypeInt === 1
    ) {
      getHomestartDeliTimeline();
    } else {
      getHubstartDeliTimeline();
    }
  }, []);

  const getTripHubStartSteps = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/hubdeliverytimelines?deliveryId=${summaryDetails?.fleetDeliveryAgentBookings?.id}`
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        const parsedTimeline = data?.entities?.rows?.map((item) => {
          let parsedAttachments = [];
          try {
            const parsed = JSON.parse(item.attachments || "[]");

            if (Array.isArray(parsed)) {
              parsedAttachments = parsed.flat();
            } else if (parsed && typeof parsed === "object" && parsed.url) {
              parsedAttachments = [parsed];
            } else {
              parsedAttachments = [];
            }
          } catch (err) {
            console.error("Error parsing attachments JSON", err);
          }

          return {
            ...item,
            parsedAttachments,
          };
        });        
        setStepsforStartHubDel(parsedTimeline);
      }
    } catch (error) {
      console.error("Error fetching hub details:", error);
    }
  };

  const getTripHomeStartSteps = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        `${apiUrl}/api/homedeliverytimelines?deliveryId=${summaryDetails?.fleetDeliveryAgentBookings?.id}`
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        const parsedTimeline = data?.entities?.rows?.map((item) => {
          let parsedAttachments = [];
          try {
            parsedAttachments = JSON.parse(item.attachments || "[]");
          } catch (err) {
            console.error("Error parsing attachments JSON", err);
          }
          return {
            ...item,
            parsedAttachments,
          };
        });        
        setStepsforStartHubDel(parsedTimeline);
      }
    } catch (error) {
      console.error("Error fetching home details:", error);
    }
  };

  const getHubstartDeliTimeline = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/hubdeliverytasks`);
      const data = await response.json();
      if (data) {
        const ordered = data?.entities?.rows?.sort(
          (a, b) => a?.seqId - b?.seqId
        );
        setGetHubStart(ordered);
        getTripHubStartSteps();
      }
    } catch (error) {
      console.error("Error fetching hub tasks:", error);
    }
  };

  const getHomestartDeliTimeline = async () => {
    try {
      const response = await fetch(`${apiUrl}/api/homedeliverytasks`);
      const data = await response.json();
      if (data) {
        const ordered = data?.entities?.rows?.sort(
          (a, b) => a?.seqId - b?.seqId
        );
        setGetHubStart(ordered);
        getTripHomeStartSteps();
      }
    } catch (error) {
      console.error("Error fetching home tasks:", error);
    }
  };

  const groupedSteps = getHubStart.map((task) => {
    const imagesForTask = stepsforstartHubDel
      .filter((item) => item.taskId === task.id)
      .flatMap((item) => {
        if (Array.isArray(item.parsedAttachments)) {
          return item.parsedAttachments; 
        }
        return [];
      });

    return {
      ...task,
      parsedAttachments: imagesForTask,
    };
  });

  return (
    <>
      <div className="font-semibold px-6 py-3 text-[#2c3e50]">Timeline</div>
      <Stepper sx={{ mt: 4 }} activeStep={activeStep} alternativeLabel>
        {groupedSteps?.map((step, index) => {
          const hasImage = step.parsedAttachments?.length > 0;
          const isActive = activeStep === index;

          return (
            <Step key={step.value || step.id || index}>
              <StepLabel
                StepIconComponent={(props) => (
                  <ColorStepIcon {...props} hasImage={hasImage} />
                )}
                onClick={() => setActiveStep(index)}
                style={{ cursor: "pointer" }}
              >
                <span
                  style={{
                    textDecoration: isActive ? "underline" : "none",
                    fontWeight: isActive ? "bold" : "normal",
                  }}
                >
                  {step.value || `Step ${index + 1}`}
                </span>
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>

      {!loading ? (
        <Box sx={{ mt: 4, mb: 2, textAlign: "center" }}>
          {Array.isArray(groupedSteps) &&
            groupedSteps[activeStep]?.parsedAttachments?.length > 0 && (
              <Box
                sx={{
                  mt: 4,
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: 2,
                }}
              >
                {groupedSteps[activeStep].parsedAttachments.map((img, idx) => (
                  <img
                    key={idx}
                    src={img.url}
                    alt={img.fileName}
                    className="object-cover cursor-pointer"
                    style={{
                      width: "140px",
                      height: "100px",
                      borderRadius: 8,
                    }}
                    onClick={() => {
                      handleImageOpen(img?.url ? img?.url : img?.path);
                    }}
                  />
                ))}
              </Box>
            )}
        </Box>
      ) : (
        <div className="align-center mx-auto p-4">
          <BlinkBlur color={["#cd8032", "#32cd32", "#327fcd", "#cd32cd"]} />
        </div>
      )}
    </>
  );
};

export default Steppers;
